<script>
export default {
  methods: {
    /**
     * Add event listeners with automatic teardown when component is
     * destroyed.
     */
    $addEventListener(el, eventNames, handler) {
      for (let eventName of eventNames.trim().split(/\s+/)) {
        el.addEventListener(eventName, handler)
        this.$once('hook.beforeDestroy', () => {
          el.removeEventListener(eventName, handler)
        })
      }
      return handler
    },
  },
}
</script>
